import {Typography} from '@mui/material';

export const privacyPolicyText = <Typography>
  <h3>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</h3>
  Donec quis nibh blandit, egestas ligula quis, lobortis tellus. Nulla rutrum et enim in luctus.
  Etiam ut turpis convallis, maximus tellus quis, bibendum metus. Proin at libero fringilla, dignissim purus sit amet,
  facilisis lectus. Aenean condimentum massa in est venenatis rhoncus. Nam a dui non nulla aliquam bibendum nec vel leo.
  Nullam sit amet elit porta, condimentum tellus at, finibus orci.

  <h3>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</h3>
  Pellentesque sollicitudin sem at eros varius tempus. Duis egestas non ipsum non tristique. Curabitur at tempor libero.
  Vivamus convallis varius felis sodales luctus. Curabitur condimentum sit amet purus ut blandit.
  Etiam mattis augue arcu, vel pellentesque leo pellentesque nec.

  <h3>Curabitur rhoncus justo diam, eget ultrices metus porttitor sit amet.</h3>
  Pellentesque vel velit non augue interdum ullamcorper posuere quis magna. Aliquam vel accumsan lorem.
  Cras nec blandit risus. Sed non diam quis orci maximus maximus. Praesent egestas, sapien sit amet ullamcorper lacinia,
  augue augue sagittis lorem, et pretium ipsum velit sollicitudin ipsum. Nullam vitae diam mi.

  <h3>Morbi dictum dolor nulla, vel molestie lectus tincidunt vel.</h3> Sed pellentesque tortor ac leo dignissim,
  at pretium lorem mattis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
  Maecenas dictum justo risus, quis vulputate tellus consectetur at. Sed a tempor dui.
  Vivamus ornare lacus augue, nec rhoncus sapien semper sed. Integer fringilla mollis sollicitudin. Praesent mi nibh,
  viverra quis ligula in, molestie porta felis. Integer ultricies sagittis efficitur. Aliquam erat volutpat.
  In sodales condimentum diam, sed mattis odio bibendum volutpat. Mauris varius est vel quam bibendum efficitur.
  Fusce euismod lectus et rhoncus consequat. In leo diam, ornare ut facilisis a, laoreet pulvinar sem.

  <h3>Sed vestibulum eleifend leo ac pellentesque.</h3>
  Integer pulvinar ex eget tortor cursus, ut semper ligula tristique. Ut aliquet lacus vel porta varius.
  Sed sed libero tortor. Nam ut dolor ut libero placerat maximus. Vestibulum elementum orci vel vehicula ultricies.
  Donec blandit iaculis leo, non malesuada nibh ultricies vitae. Nullam vestibulum eros nisl,
  id bibendum est tincidunt eu. Integer pulvinar scelerisque elit non molestie.
</Typography>;
